(function($) {
	
	const $block = $('.wp-block-metropolis-carousel');
	
	$block.each( function() {
		
		let $container = $(this);
		let selector = '.wp-block-metropolis-carousel';
		const looped = $container.hasClass('is-looped');
		const $children = $container.children().children();
		const id = $container.attr('id');
		
		if( $children.first().is('.wp-block-metropolis-posts') ) {
			$container = $children;
			selector = '.wp-block-metropolis-posts';
		} 
	
		$container.addClass('swiper').children().addClass('swiper-wrapper').children().addClass('swiper-slide').ready(function () {
						
			const carousel = new Swiper($container[0], {
				
				slidesPerView: 'auto',
				spaceBetween: 24,
    			containerModifierClass: 'carousel-',
				loop: looped,
				navigation: {
					nextEl: '.wp-block-metropolis-carousel-navigation[data-carousel-id="' + id + '"] .next',
					prevEl: '.wp-block-metropolis-carousel-navigation[data-carousel-id="' + id + '"] .prev',
					disabledClass: 'disabled',
					hiddenClass: 'hidden',
				},
				pagination: {
					el: '.wp-block-metropolis-carousel-pagination[data-carousel-id="' + id + '"]',
    				type: 'bullets',
					clickable: true,
				},
				
			});
			
		});
	
	});
	
})(jQuery);